import { IngestStatus } from "../../../Pages/admin/Ingest/IngestIndex/IngestProcessing/ingest-processing";
import { Distinct } from "../../../Utils/helpers";
import ApiClient from "../api-client";
import { EnvType } from "../services";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetItemsListResponse } from "../Types/get-items-list-response";
import { GetJobsResponse } from "../Types/get-jobs-response";
import { GetPlatformsNamesResponse } from "../Types/get-platform-names-response";
import { GetWorkflowUserTasksKpiResponse } from "../Types/get-workflow-user-tasks-kpi-response";
import { MakeOperationRequest } from "../Types/make-operation-request";
import { WorkflowType } from "../Types/workflow-type";

import {
  GetCountOfInstanceThatMatchStatuses,
  MapInstanceInfosToWorkflowRows,
  WorkflowProps,
} from "../Workflow/workflow-api-service";
import CockpitApiClient, { ICockpitApiClient } from "./cockpit-api-client";

export default class CockpitService {
  cockpitApiClient: ICockpitApiClient;

  constructor(envType: EnvType) {
    this.cockpitApiClient = new CockpitApiClient(new ApiClient(envType), envType);
  }

  async GetKpiWorkflowData(
    workflowType: WorkflowType,
    startDate: string,
    endDate: string
  ): Promise<GetWorkflowUserTasksKpiResponse> {
    return await this.cockpitApiClient.GetKpiWorkflowData(workflowType, startDate, endDate);
  }

  async GetOrdersList(): Promise<GetItemsListResponse> {
    return await this.cockpitApiClient.GetOrdersList();
  }

  async GetIngestInstances(): Promise<WorkflowProps> {
    const instances = (await this.cockpitApiClient.GetIngestInstances()).instances;
    const computedInstances = MapInstanceInfosToWorkflowRows(instances);

    const data: WorkflowProps = {
      rows: computedInstances,
      countInstances: {
        countInstancesAccepted: GetCountOfInstanceThatMatchStatuses(computedInstances, [IngestStatus.Accepted]),
        countInstancesQcInProgress: GetCountOfInstanceThatMatchStatuses(computedInstances, [IngestStatus.QcInProgress]),
        countInstancesProcessing: GetCountOfInstanceThatMatchStatuses(computedInstances, [
          IngestStatus.Running,
          IngestStatus.QcInProgress,
        ]),
        countInstancesPendingQC: GetCountOfInstanceThatMatchStatuses(computedInstances, [IngestStatus.PendingQC]),
        countInstancesRejected: GetCountOfInstanceThatMatchStatuses(computedInstances, [IngestStatus.Rejected]),
        countInstancesError: GetCountOfInstanceThatMatchStatuses(computedInstances, [
          IngestStatus.WorkflowError,
          IngestStatus.Aborted,
        ]),
        countInstancesWaitingMezz: GetCountOfInstanceThatMatchStatuses(computedInstances, [IngestStatus.WaitingMezz]),
        countInstancesMissingMetadata: GetCountOfInstanceThatMatchStatuses(computedInstances, [
          IngestStatus.MissingMetadata,
        ]),
      },
      filtersData: {
        createdByNames: computedInstances
          .map((x) => x.createdByUserName)
          .filter(Distinct)
          .sort(),
        providersNames: computedInstances
          .map((x) => x.providerName)
          .filter(Distinct)
          .sort(),
      },
    };
    return data;
  }

  async ListJobs(): Promise<GetJobsResponse> {
    return await this.cockpitApiClient.ListJobs();
  }

  async GetPlatforms(): Promise<GetPlatformsNamesResponse> {
    return await this.cockpitApiClient.GetPlatforms();
  }

  async MakeAdminOperation(request: MakeOperationRequest): Promise<GenericResponseStd> {
    return await this.cockpitApiClient.MakeAdminOperation(request);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.cockpitApiClient.GetApiUrl();
  }
}
